import axios from "axios";
import Cookies from "js-cookie";
export class Http {
  static async request(
    method: string,
    url: string,
    data: any = null,
    headers: any = null,
    signal:any=null
  ) {
    try {
      const result = await axios({
        method,
        url,
        data,
        headers,
        signal
      });

      return result.data;
    } catch (error: any) {
      if (error.response.status === 401) {
        if (url.indexOf("login") === -1) {
          Cookies.remove("token");
          window.location.href = "/";
        }
      }
      throw error;
    }
  }
}
